// Polyfill process for Vercel AI SDK
if (typeof process === "undefined") {
  (window as any).process = { env: {} };
}

function initAssistantStart() {
  const assistantContainerStart: HTMLDivElement = document.createElement("div");
  assistantContainerStart.classList.add("assistant-container-start");
  const image_url = SETTINGS.wkfgContentBaseUrl + "Tenant/" + SETTINGS.tenant.Assistant;
  const i18nKey =
    window.innerWidth < 1280 || window.innerHeight < 768 ? "TinaStartupSmallScreen" : "TinaStartup";
  fetch(SETTINGS.wkfgBackendUrl + `metamodell/query?table=I18N&where.Key=${i18nKey}`).then(
    (response) =>
      response.json().then((json) => {
        assistantContainerStart.innerHTML = `
        <div class="assistant-avatar assistant-avatar-button shadow-very-wide" style="background-image:url(${image_url})"></div>
        <div class="assistant-message shadow-very-wide">
            ${json?.I18N?.[0]?.Text}
            ${
              i18nKey === "TinaStartupSmallScreen"
                ? '<div class="assistant-ok-container"><button class="assistant-ok-button primary-button">OK</button></div>'
                : ""
            }
        </div>`;
        document.body.append(assistantContainerStart);
        if (i18nKey === "TinaStartupSmallScreen") {
          assistantContainerStart.querySelector(".assistant-ok-button")?.addEventListener(
            "click",
            () => {
              moveAssistantIfAppReady();
            },
            { once: true }
          );
        } else {
          setTimeout(moveAssistantIfAppReady, 1000);
        }
      })
  );
}
function moveAssistantIfAppReady() {
  if (document.body.classList.contains("holoAppReady")) {
    const assistantContainerStart = document.querySelector(".assistant-container-start");
    const startAssistant: HTMLElement = document.querySelector(
      ".assistant-container-start .assistant-avatar"
    );
    const realAssistant: HTMLElement = document.querySelector(
      ".assistant-container .assistant-avatar"
    );

    if (realAssistant != null && startAssistant != null) {
      const rectStart = startAssistant.getBoundingClientRect();
      const rectReal = realAssistant.getBoundingClientRect();

      const diffX = rectReal.x + rectReal.width / 2 - rectStart.x - rectStart.width / 2;
      const diffY = rectReal.y + rectReal.height / 2 - rectStart.y - rectStart.height / 2;
      startAssistant.style.transform = `translate(${diffX}px, ${diffY}px)`;
    }

    assistantContainerStart.classList.add("move-to-final");
    document.querySelector(".assistant-container")?.classList.remove("hidden");
    assistantContainerStart.addEventListener("transitionend", () => {
      assistantContainerStart.classList.add("final");
    });
  } else {
    setTimeout(moveAssistantIfAppReady, 100);
  }
}
const params = new URLSearchParams(window.location.search);
const pageNameFromParam = params.get("page");
const tutorialParam = params.get("tutorial");
// debugger;
if (pageNameFromParam == null && tutorialParam !== "false") {
  initAssistantStart();
}
